import React, { PureComponent } from 'react';
import LogInForm from './components/LogInForm';
import { withRouter } from 'react-router-dom';
import framework_image from '../../../img/framework_img.png';
import '../../../scss/component/login-form.scss';

class LogIn extends PureComponent {
  render () {
    const { state } = this.props.location

    return (
      <div className='account'>
        <div className='account__wrapper'>
          <div className='account__card account__card__adjust ' id="login-page">
            <div className="col-md-6">
              <img src={framework_image} alt="Posture-login"/>
              <p>
                Don't have an account? <a id='signinLink' href='https://postured.io/tryit/'>Signup</a></p>
            </div>
            <div className="col-md-6">
              <div className='account__head' >
                <h3 className='account__logo-accent'>Welcome to Posture</h3>
                <h4 className='account__subhead subhead'>Agile Compliance. Simplified.</h4>
              </div>
              {state && state.haveMessage ?
                <LogInForm passwordChanged={state ? state.haveMessage : null} msg={state ? state.msg : null} />
                : <LogInForm />}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(LogIn)



// WEBPACK FOOTER //
// ./src/components/account/log_in/LogIn.js